import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-start justify-center gap-2 md:h-10" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Pill',
  props: {
  items: {
    type: Array as () => any[],
    required: true,
  },
  classes: {
    type: String,
    default: '',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.items.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.items, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item.id,
            to: item.path,
            class: _normalizeClass([
        'px-4 text-sm font-medium rounded-full',
        __props.classes ? __props.classes : 'bg-blue-500 text-white'
      ])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}
}

})